import { render, staticRenderFns } from "./MemberSearchField.vue?vue&type=template&id=488dd1a4&"
import script from "./MemberSearchField.vue?vue&type=script&lang=js&"
export * from "./MemberSearchField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports